import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import agentProfileSvg from "shared/icons/boomLeasingAgentProfile.svg";
import { cx } from "shared/utils";
import type { IncomingOutcomeCopy } from "./teamFirst";

export function AiAgentAvatar({
  size = 48,
  className
}: {
  size?: number;
  className?: string;
}) {
  return (
    <img
      src={agentProfileSvg}
      alt=""
      width={size}
      height={size}
      className={cx(
        "block shrink-0 rounded-full shadow-[0_4px_11.3px_0_rgba(251,60,160,0.26)]",
        className
      )}
    />
  );
}

export function OutcomeIcon({
  tone,
  size = 48
}: {
  tone: IncomingOutcomeCopy["tone"];
  size?: number;
}) {
  if (tone === "ai") return <AiAgentAvatar size={size} />;
  return (
    <span
      style={{ width: size, height: size }}
      className="grid shrink-0 place-items-center rounded-full bg-[#FEF4E3] text-[#B5760A]"
    >
      <HugeiconsIcon icon={InformationCircleIcon} size={22} />
    </span>
  );
}

export function TeamFirstProgressBar({
  total,
  remaining
}: {
  total: number;
  remaining: number;
}) {
  const elapsedPercent = Math.min(100, (100 * (total - remaining)) / total);
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={Math.round(total - remaining)}
      aria-label="Time until the AI agent picks up"
      className="relative h-[9px] w-full max-w-[282px] rounded-full bg-[rgba(28,29,34,0.10)]"
    >
      <span
        className="absolute inset-y-0 left-0 rounded-full bg-[linear-gradient(90deg,#E6007E_0%,#FF4FA8_60%,#FFA6D4_100%)] shadow-[0_4px_11.3px_0_rgba(251,60,160,0.26)] transition-[width] duration-200 ease-linear"
        style={{ width: `${elapsedPercent.toFixed(1)}%` }}
      />
    </div>
  );
}
